import React, { useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import QrReader from 'react-qr-scanner';
import '../styles/QrScannerComponent.css';

const QrScanner3Component = () => {
  const { po_number, cart } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const scannerMessage = `Escanea ${cart}`;
  const [scannerActive, setScannerActive] = useState(true);
  const [lastScannedCode, setLastScannedCode] = useState(null);

  const handleScan = (data) => {
    if (data && data.text && data.text !== lastScannedCode) {
      const normalizedResult = data.text.trim();
      setLastScannedCode(normalizedResult); // Store the last scanned code
      console.log('Código QR escaneado:', normalizedResult);

      if (normalizedResult === cart) {
        setScannerActive(false); // Detener el escáner
        alert('Código QR escaneado correctamente. Redirigiendo...');

                        console.log('QrScanner3 - pickingStartTime from location.state:', location.state?.pickingStartTime);
        console.log('QrScanner3 - Full location.state:', location.state);

        const storageKey = `pickingStartTime_${po_number}_${cart}`;
        const pickingStartTimeFromStorage = localStorage.getItem(storageKey);
        console.log('QrScanner3 - pickingStartTime from localStorage:', pickingStartTimeFromStorage);

        // Use localStorage as fallback if location.state is null
        const pickingStartTime = location.state?.pickingStartTime || pickingStartTimeFromStorage;

        navigate(`/admin/${po_number}/${cart}/productos`, {
          state: {
            orderData: location.state?.orderData,
            pickingStartTime: pickingStartTime
          }
        });
      } else {
        setScannerActive(false); // Temporarily stop scanner
        alert('El código QR no coincide con el abarrote. Intenta nuevamente.');
        // Reset after alert is closed
        setTimeout(() => {
          setLastScannedCode(null);
          setScannerActive(true);
        }, 100);
      }
    }
  };

  const handleError = (err) => {
    console.error('Error al escanear el código QR:', err);
    alert('Ocurrió un error al intentar escanear. Verifica que la cámara esté disponible.');
  };

  const handleBackNavigation = () => {
    navigate(`/admin/${po_number}`);
  };

  return (
    <div className="qrscanner-container">
      <button onClick={handleBackNavigation} className="qrscanner-back-button">
        &#8592;
      </button>

      <h1 className="qrscanner-title">{scannerMessage}</h1>

      <div className="qrscanner-video-container">
        {scannerActive ? (
          <QrReader
            delay={300}
            onError={handleError}
            onScan={handleScan}
            style={{ width: '100%' }}
            constraints={{
              video: {
                facingMode: 'environment',
              },
            }}
          />
        ) : (
          <div className="loading-container">
            <div className="spinner"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QrScanner3Component;
